import { render, staticRenderFns } from "./BoxByFarmChart.vue?vue&type=template&id=a84a58a8"
import script from "./BoxByFarmChart.vue?vue&type=script&lang=js"
export * from "./BoxByFarmChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports